module.exports = __webpack_public_path__ + "media/images/icons/icon-product_1-3a2fd8a9b29d0123a333151049efdea5.svg";